import React, { Component } from 'react'
import PropTypes from 'prop-types'
import moment from 'moment'
import 'react-vis/dist/style.css'
import {curveCatmullRom} from 'd3-shape';
import {
  XYPlot,
  XAxis,
  YAxis,
  LineSeries,
  Hint,
  makeWidthFlexible
} from 'react-vis'

// Styles
const styles = theme => ({
  root: {
      flexGrow: 1,
      marginTop: '5%'
  },
  graphLine: {
      color: theme.palette.background.paper
  }
})

const FlexibleXYPlot = makeWidthFlexible(XYPlot)

const DAILY_GRAPH_TYPE = 'DAILY'
const WEEKLY_GRAPH_TYPE = 'WEEKLY'
const MONTHLY_GRAPH_TYPE = 'MONTHLY'
const YEARLY_GRAPH_TYPE = 'YEARLY'


const hourTickFormat = tick => {
  return moment.unix(tick).format('MMM Do HH:mm')
}

const dayTickFormat = tick => {
  return moment.unix(tick).format('MMM Do HH:mm')
}

const monthTickFormat = tick => {
  return moment.unix(tick).format('MMM Do')
}

class LSILineGraph extends Component {
  constructor(props) {
    super(props)

    this.state = {
      currentValue: null,
      hintCount: 0
    }
    this._rememberValue = this._rememberValue.bind(this)
    this._forgetValue = this._forgetValue.bind(this)
  }

  _rememberValue(currentValue) {
    const roundedValue = {x: currentValue.x.toFixed(2), y: currentValue.y.toFixed(2)}
    this.setState({currentValue: roundedValue, hintCount: this.state.hintCount + 1})
  }

  _forgetValue() {
    this.setState({
      currentValue: null
    })
  }

  static propTypes = {
    timePeriod: PropTypes.oneOf([DAILY_GRAPH_TYPE, WEEKLY_GRAPH_TYPE, MONTHLY_GRAPH_TYPE, YEARLY_GRAPH_TYPE])
  }

  graphTypes = {
    daily: DAILY_GRAPH_TYPE,
    weekly: WEEKLY_GRAPH_TYPE,
    monthly: MONTHLY_GRAPH_TYPE,
    yearly: YEARLY_GRAPH_TYPE
  }

  getTickCount = () => {
    const { timePeriod } = this.props

    switch (timePeriod) {
      case DAILY_GRAPH_TYPE:
        return 13
      case WEEKLY_GRAPH_TYPE:
        return 8
      case MONTHLY_GRAPH_TYPE:
        return 30
      case YEARLY_GRAPH_TYPE:
        return 13
      default:
        return null
    }
  }

  getTickFormat() {
    const { timePeriod } = this.props

    switch (timePeriod) {
      case DAILY_GRAPH_TYPE:
        return hourTickFormat
      case WEEKLY_GRAPH_TYPE:
        return dayTickFormat
      case MONTHLY_GRAPH_TYPE:
        return monthTickFormat
      case YEARLY_GRAPH_TYPE:
        return monthTickFormat
      default:
        return null
    }
  }

  getHintPoints(func) {
    return (points) => {
      return [
        {title: 'Stress Level', value: points.y},
        {title: 'Time', value: func(points.x)}
      ]
    }
  }

  render() {
    const { lsiHistory, timeRange, classes} = this.props
    const { currentValue } = this.state
    const tickFormat = this.getTickFormat()
    const hintPointsFormat = this.getHintPoints(tickFormat)
    const tickCount = this.getTickCount()

    return (
      <div>
        <FlexibleXYPlot height={300} margin={{bottom: 80, left:60}} xType="linear" xDomain={timeRange} yDomain={[0, 10]} onMouseLeave = {this._forgetValue}>
          <XAxis title={'Time of day'} tickFormat={x => tickFormat(x)} tickTotal={tickCount} tickLabelAngle={-45}/>
          <YAxis title={'stress'}/>
          {currentValue ?
            <Hint value={currentValue} format={hintPointsFormat} key = {this.state.hintCount}/>:
            null
          }
          <LineSeries
            data={lsiHistory}
            color={'rgb(100, 221, 249)'}
            onNearestX={this._rememberValue}
            curve={curveCatmullRom.alpha(0.5)}
            />
            {this.props.children}
        </FlexibleXYPlot>
      </div>
    )
  }
}

export {
  LSILineGraph,
  DAILY_GRAPH_TYPE,
  WEEKLY_GRAPH_TYPE,
  MONTHLY_GRAPH_TYPE,
  YEARLY_GRAPH_TYPE
}
